module.exports = __webpack_public_path__ + "img/3.73f498a4.jpg";